import { render, staticRenderFns } from "./detail_fault.vue?vue&type=template&id=135544cb&scoped=true"
import script from "./detail_fault.vue?vue&type=script&lang=js"
export * from "./detail_fault.vue?vue&type=script&lang=js"
import style0 from "./detail_fault.vue?vue&type=style&index=0&id=135544cb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135544cb",
  null
  
)

export default component.exports